import { render, staticRenderFns } from "./AddNotesModal.vue?vue&type=template&id=eb130efe&scoped=true&"
import script from "./AddNotesModal.vue?vue&type=script&lang=js&"
export * from "./AddNotesModal.vue?vue&type=script&lang=js&"
import style0 from "./AddNotesModal.vue?vue&type=style&index=0&id=eb130efe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb130efe",
  null
  
)

export default component.exports